export enum ModalDefinitions {
    LARGE_MODAL_WIDTH = '600px',
    DEFAULT_MODAL_WIDTH = '450px',
    INFORMATION_MODAL_WIDTH = '350px'
}
